import {useEffect, useState} from 'react'
import {PageTitle} from '../../_metronic/layout/core'
import {KTSVG} from '../../_metronic/helpers'
import { Form } from 'react-bootstrap'
import ReactPaginate from 'react-paginate';
import axios from 'axios'
import {toast} from 'react-toastify';
import Modal from 'react-bootstrap/Modal'
import { Funnel,  Calendar } from 'react-bootstrap-icons';
// import 'dotenv/config'
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css fil

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useLocation } from 'react-router-dom';

const Blogs = () => {

    // const location = useLocation()
    const token =  localStorage.getItem('kt-auth-react-v.api_token')
    const [offset, setOffset] = useState(0);
    const [fromDate, setFromDate] = useState(''); //new Date().toISOString().slice(0, 10) '2020-01-01'
    const [toDate, setToDate] = useState('');
    const [sortBy, setSortBy] = useState(-1);
    const [contentLoading, setContentLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [allData, setAllData] = useState([]);
    const [pageCount, setPageCount] = useState(0)
    const [totalItems, setTotalItems] = useState(0)
    const [dataPerPage, setDataPerPage] = useState(10)
    const [lgshow, setShow] = useState(false);
    const [blogTitle, setBlogTitle] = useState('');
    const [blogDescription, setBlogDescription] = useState('');
    const [blogMetaTitle, setBlogMetaTitle] = useState('');
    const [blogMetaKeywords, setBlogMetaKeywords] = useState('');
    const [blogMetaDescription, setBlogMetaDescription] = useState('');
    // const [blogDescription, setBlogDescription] = useState('');
    const [blogStatus, setBlogStatus] = useState(1);
    const [quillValue, setQuillValue] = useState('');
    const [fileFormatErrorThumbnail, setFileFormatErrorThumbnail] = useState(false);
    const [isEditThumbnail, setIsEditThumbnail] = useState(false);
    const [fileSizeErrorThumbnail , setFileSizeErrorThumbnail] = useState(false);
    const [fileFormatError, setFileFormatError] = useState(false);
    const [thumbnail_selected, setThumbnailSelected] = useState("");

    
    const [modalTitle, setModalTitle] = useState('View Order Details');
    const [viewMode, setViewMode] = useState(false);
    
    const [blogId, setBlogId] = useState('');
    const [calenderDates, setCalenderDates] = useState([
        {
            startDate: null,
            endDate: new Date(),
            key: 'selection',
            
        }
    ]);
    // const theme = 'snow';

    const modules = {
        toolbar: [
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          ['bold', 'italic', 'underline','strike', 'blockquote'],
          [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
        //   color
            [{ 'color': [] }, { 'background': [] }],
            // font
            [{ 'font': [] }],
            // align
            [{ 'align': [] }],
          ['link'],
          ['clean']
        ],
      }
    
    // const  formats = [
    //     'header',
    //     'bold', 'italic', 'underline', 'strike', 'blockquote',
    //     'list', 'bullet', 'indent',
    //     'link', 'image'
    //   ],
    // const { quill, quillRef } = useQuill({ theme, modules });
    
    useEffect(() => {
        getData();
    }, [sortBy, offset, calenderDates, fromDate, toDate, searchQuery])

    const getAllData = (data, offset) => {
        return (
            
            data.map(item =>{
                // const blog_data = order.order_details[0];

            
                return (
                <tr key={item._id}>
                    <td></td>
                    <td>
                        {item?.title}
                    </td>
                    <td>
                        {item?.meta_title}
                    </td>
                    <td>
                        {item?.meta_keywords}
                    </td>
                    <td>
                        {/* status */}
                        <span className={`badge badge-light-${item?.status === 1 ? 'success' : 'danger'} badge-inline`}>
                            {item?.status === 1 ? 'Active' : 'Inactive'}
                        </span>
                    </td>
                   
                    <td className=''>
                        <div className='d-flex flex-shrink-0'>
                            <button onClick={() => viewDetails(item?._id)}
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1' title='View Details'
                            >
                            <KTSVG
                                path='/media/icons/duotune/general/gen028.svg'
                                className='svg-icon-3 text-primary'
                            />
                            </button>     

                            <button onClick={() => editBlog(item._id)}
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            >
                            <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3 text-primary' />
                            </button>
                            <button onClick={() => deleteBlog(item._id)}
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm '
                            >
                            <KTSVG
                                path='/media/icons/duotune/general/gen027.svg'
                                className='svg-icon-3 text-primary text-white'
                            />
                            </button>   
                            
                        </div>
                    </td>
                </tr>
                )
            })
        )
    }
    
    const getData = async () => {
        setContentLoading(true);
        
        // if (searchQuery === '' && fromDate === undefined && toDate === undefined && sortBy === -1) {
            // ?from_date=${fromDate}&to_date=${toDate}&sort=${sortBy}&keyword=${searchQuery}&offset=${offset}&limit=${dataPerPage}`, { headers: {"Authorization" : ` ${token}`} }
            
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/blogs?from_date=${fromDate}&to_date=${toDate}&sort=${sortBy}&keyword=${searchQuery}&offset=${offset}&limit=${dataPerPage}`)
            
            const data = res.data;
            const blog_data = data.blogs;
            const blogData = getAllData(blog_data);
            setAllData(blogData);
            setPageCount(Math.ceil(data.total / dataPerPage));
            setTotalItems(data.total);
        // }else{
        //     getDataBySearch();
           
        // }
        setContentLoading(false);
    }

    const handlePageClick = (event) => {
        const newOffset = (event.selected * dataPerPage);
        // console.log(newOffset);
        setOffset(newOffset);
        setDataPerPage(dataPerPage);
    };
    const viewDetails = (blog_id) => {
        try{
            axios.get(`${process.env.REACT_APP_API_URL}/blogs/${blog_id}`, { headers: {"Authorization" : ` ${token}`} })
            .then(res => {
                if(res.data.statusCode === 200){
                    const data = res.data.blog;
                    setBlogId(data._id);
                    setBlogTitle(data.title);
                    setBlogMetaTitle(data.meta_title);
                    setBlogMetaKeywords(data.meta_keywords);

                    setBlogMetaDescription(data.meta_description);
                    setBlogStatus(data.status);
                    setBlogDescription(data.description);
                    setQuillValue(data.content);
                    setThumbnailSelected(data.featured_image);
                    // setThumbnail(res.data.thumbnail);
                    setIsEditThumbnail(true);
                    // if(quill){
                    //     quill.clipboard.dangerouslyPasteHTML(data.content);
                    // }
                    // console.log(data.content);
                    // setBlogDescription(data.description);
                    setViewMode(true);
                    handleShow("", 'View Blog', 'View Blog', true);
                }else{
                    toast.error("Something went wrong");
                }
            }).catch(err => {
                console.log(err);
                toast.error("Something went wrong");
            })

        }catch(err){
            console.log(err);
        }
    }
    const handleThumbnail = (e) => {
        setFileSizeErrorThumbnail(false);
        setFileFormatErrorThumbnail(false);

        if(e.target.files[0].size > 300000){
            setFileSizeErrorThumbnail(true);
            e.target.value = null;
            return;
        }else{
            if(e.target.files[0].type !== 'image/jpeg' && e.target.files[0].type !== 'image/png' && e.target.files[0].type !== 'image/jpg' && e.target.files[0].type !== 'image/svg' && e.target.files[0].type !== 'image/svg+xml'  && e.target.files[0].type !== 'image/webp'){
                // toast.error('File format not supported');
                setFileFormatErrorThumbnail(true);
                e.target.value = null;
                return;
            }else{
                setThumbnailSelected(e.target.files[0]);
                setIsEditThumbnail(false)
            }
        }
    }

    const handleShow = (e, title="View Blog", button="View Blog", viewMode=false) => {
        if(viewMode){
            setViewMode(true);
        }else{
            setViewMode(false);
        }
    
    // console.log(title, button);
        setModalTitle(title);
        setModalTitle(button);
        setShow(true);
    }
    const handleClose = () => {
        setBlogId('');
        setBlogTitle('');
        setBlogMetaTitle('');
        setBlogMetaKeywords('');
        setBlogMetaDescription('');
        setBlogStatus(1);
        setQuillValue('');
        setBlogDescription('');
        setThumbnailSelected('');
        setFileSizeErrorThumbnail(false);
        setFileFormatErrorThumbnail(false);
        setIsEditThumbnail(false);

        // quillRef.current = null;
        
        // if(quill){
        //     // destroy quill
        //     quill.clipboard.dangerouslyPasteHTML('');
        //     // remove quill

        // }
        // quill to empty
        // quill.root.innerHTML = '';
        setViewMode(false);

        setShow(false);

    }

    const handleBlogForm = (e) => {
        e.preventDefault();
        if(blogId !== ''){
            const formData = new FormData();
            formData.append('title', blogTitle);
            formData.append('meta_title', blogMetaTitle);
            formData.append('meta_keywords', blogMetaKeywords);
            formData.append('meta_description', blogMetaDescription);
            formData.append('status', blogStatus);
            formData.append('content', quillValue);
            formData.append('description', blogDescription);
            formData.append('photo', thumbnail_selected);
            // console.log('inside if statement, patch api')
            
            const btn = document.getElementById('btn-submit2');
            btn.disabled = true;
            // spinner
            btn.innerHTML = `
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span class="visually-hidden">Loading...</span>
            `;
            // , { headers: {"Authorization" : ` ${token}`} }
            try{
                axios.patch(`${process.env.REACT_APP_API_URL}/blogs/${blogId}`, formData)
                .then(res => {
                    if(res.data.statusCode === 200){
                        handleClose();
                        getData();
                        toast.success(res.data.message);
                    }else{
                        toast.error(res.data.message);
                    }
                })
                .catch(err => {
                    toast.error(err.response.data.message);
                }
                )
            }catch(err){
                console.log(err);
                toast.error("Something went wrong!")
            }
            finally{
                btn.disabled = false;
                btn.innerHTML = 'Update Blog';
            }
        }else{
            const formData = new FormData();
            formData.append('title', blogTitle);
            formData.append('meta_title', blogMetaTitle);
            formData.append('meta_keywords', blogMetaKeywords);
            formData.append('meta_description', blogMetaDescription);
            formData.append('status', blogStatus);
            formData.append('content', quillValue);
            formData.append('description', blogDescription);
            formData.append('photo', thumbnail_selected);
        
            const btn = document.getElementById('btn-submit2');
            btn.disabled = true;
            // spinner
            btn.innerHTML = `
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span class="visually-hidden">Loading...</span>
            `;
            // return;
            // { headers: {"Authorization" : ` ${token}`} }
            try{
                axios.post(`${process.env.REACT_APP_API_URL}/blogs/`, formData  )
                .then(res => {
                    if(res.data.statusCode === 201){
                        handleClose();
                        getData();
                        toast.success(res.data.message);
                    }else{
                        toast.error(res.data.message);
                    }
                })
                .catch(err => {
                    toast.error(err.response.data.message);
                }
                )
            }catch(err){
                console.log(err);
                toast.error("Something went wrong!")
            }finally{
                btn.disabled = false;
                btn.innerHTML = 'Upload New Blog';
            }
        }
    }

    const editBlog = (blog_id) => {
    // , { headers: {"Authorization" : ` ${token}`} }
        try{
            axios.get(`${process.env.REACT_APP_API_URL}/blogs/${blog_id}`)
            .then(res => {
                // console.log(res);
                if(res.data.statusCode === 200){
                    // console.log("edit blog");
                    // console.log(res.data.blog);
                    const data = res.data.blog;
                    // console.log(data);
                    setBlogId(data._id);
                    setBlogTitle(data.title);
                    setBlogMetaTitle(data.meta_title);
                    setBlogMetaKeywords(data.meta_keywords);
                    setBlogMetaDescription(data.meta_description);
                    setQuillValue(data.content);
                    setBlogDescription(data.description);
                    setThumbnailSelected(data.featured_image);
                    // setThumbnail(res.data.thumbnail);
                    setIsEditThumbnail(true);
                    // quill to set data
                    // quill.root.innerHTML = data.content;
                    // if(quill){
                    //     quill.clipboard.dangerouslyPasteHTML(data.content);
                    // }
                    // quill.clipboard.dangerouslyPasteHTML(data.content);
                    setBlogStatus(data.status);
                    handleShow("", 'Update Blog', 'Update Blog', false);
                }else{
                    toast.error(res.data.message);
                }
            })
            .catch(err => {
                toast.error("Something went wrong-----catch!");
            }
            )
        }catch(err){
            console.log(err);
            toast.error("Something went wrong!")
        }
    }

    const deleteBlog = (blog_id) => {
        // , { headers: {"Authorization" : ` ${token}`}}
        try{
            // confirm
            if(window.confirm("Are you sure you want to delete this blog?")){
                axios.delete(`${process.env.REACT_APP_API_URL}/blogs/${blog_id}`)
                .then(res => {
                    if(res.data.statusCode === 200){
                        getData();
                        toast.success(res.data.message);
                    }else{
                        toast.error(res.data.message);
                    }
                })
                .catch(err => {
                    toast.error(err.response.data.message);
                }
                )
            }
        }catch(err){
            console.log(err);
            toast.error("Something went wrong!")
        }

    }
  


    const changeDataRange = (e) => {
        setCalenderDates([e.selection]);
        // convert "Tue Mar 14 2023 00:00:00 GMT+0500 (Pakistan Standard Time)" to "2023-03-14"
        const startdate = new Date(e.selection.startDate);
        const enddate = new Date(e.selection.endDate);
        const startYear = startdate.getFullYear();
        const startMonth = startdate.getMonth()+1;
        const startDay = startdate.getDate();
        const endYear = enddate.getFullYear();
        const endMonth = enddate.getMonth()+1;
        const endDay = enddate.getDate();
        const startDate = `${startYear}-${startMonth}-${startDay}`;
        const endDate = `${endYear}-${endMonth}-${endDay}`;

        setFromDate(startDate);
        setToDate(endDate);
       
    }

   
    return (
        <>
            <PageTitle breadcrumbs={[]}>Manage Blogs</PageTitle>
            <div className={`card card-light`}>
                <div className='card-header border-0 pt-5'>
                    <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bold fs-3 mb-1'>Total Blogs <span className='p-1 mt-1 fw-semibold fs-7 bg-primary text-white rounded'>{totalItems<10?'0'+totalItems:totalItems}</span></span>
                    
                    </h3>
                    <div
                    className='card-toolbar'
                    data-bs-toggle='tooltip'
                    data-bs-placement='top'
                    data-bs-trigger='hover'
                    title='Click to add a user'
                    >
                    <button
                        onClick={e=>handleShow(e, "Upload New Blog", "Upload New Blog")}
                        className='btn btn-sm btn-light-primary'
                        // data-bs-toggle='modal'
                        data-bs-target='#category_modal'
                    >
                        <KTSVG path='media/icons/duotune/arrows/arr075.svg' className='svg-icon-3 ' />
                        New Blog
                    </button>
                    </div>
                </div>
                <div className='d-flex px-5'>
                        {/* <div className='card-toolbar'> */}
                            <div className='min-w-200px pe-2'>
                                {/* <Select options={patientSelect} onChange={e=>setPatientSearch(e.value)} placeholder="Select Patient" /> */}
                                <input type="text" className="form-control" placeholder="Search" onChange={e=>setSearchQuery(e.target.value)} value={searchQuery} />
                            </div>
                            
                            {/* from date - to date calender */}
                            <div className='dropdown dropdown-inline'>
                                <button
                                type='button'
                                className='btn btn-sm btn-light-primary'
                                data-bs-toggle='dropdown'
                                aria-haspopup='true'
                                aria-expanded='false'
                                >
                                    <Calendar size={18}
                                    path='/media/icons/duotune/arrows/arr072.svg'
                                    className='svg-icon-2 svg-icon-gray-500'
                                    />
                                </button>
                                <div className='dropdown-menu dropdown-menu-sm dropdown-menu-end'>
                                    {/*begin::Navigation*/}

                                    <DateRange
                                        editableDateInputs={true}
                                        onChange={item => changeDataRange(item)}
                                        moveRangeOnFirstSelection={false}
                                        ranges={calenderDates}
                                        />
                                    </div>
                            </div>
                            &nbsp;
                            {/* sorting dropdown */}
                            <div className='dropdown dropdown-inline'>
                                <button
                                type='button'
                                className='btn btn-sm btn-light-primary'
                                data-bs-toggle='dropdown'
                                aria-haspopup='true'
                                aria-expanded='false'
                                >
                                    <Funnel size={18}
                                    path='/media/icons/duotune/arrows/arr072.svg'
                                    className='svg-icon-2 svg-icon-gray-500'
                                    />
                                </button>
                                
                                <div className='dropdown-menu dropdown-menu-sm dropdown-menu-end'>
                                    {/*begin::Navigation*/}
                                    <ul className='navi navi-hover' style={{listStyle:"none"}}>
                                        <li className={`navi-item mb-2 pt-2 ${sortBy ===1? 'text-primary':''}` } onClick={e=>setSortBy(1)}>
                                            <span className='navi-text fw-bold' style={{cursor:"pointer"}}>Ascending</span>
                                        </li>
                                        <li className={`navi-item ${sortBy ===-1? 'text-primary':''}` } onClick={e=>setSortBy(-1)}>
                                            <span className='navi-text fw-bold' style={{cursor:"pointer"}}>Descending</span>
                                        </li>
                                    </ul>
                                </div>
                            {/* </div> */}
                            
                        </div>
                    </div>

                {/* </div> */}
                <div className='card-body py-3'>
                    <div className='table-responsive'>
                        <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                            <thead>
                                <tr className='fw-bold'>
                                    <th className='w-25px'>
                                        <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                            <input
                                            className='form-check-input'
                                            disabled
                                            type='checkbox'
                                            value='1'
                                            data-kt-check='true'
                                            data-kt-check-target='.widget-9-check'
                                            />
                                        </div>
                                    </th>
                                    <th className='min-w-150px'>Blog Title</th>
                                    <th className='min-w-150px'>Meta Title</th>
                                    <th className='min-w-150px'>Keywords</th>
                                    <th className='min-w-150px'>Status</th>
                                    <th className='min-w-50px'>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {allData}
                            </tbody>
                        </table>

                        
                        <div className='text-center'>
                            {/* <span>{totalItems}</span> */}
                            <ReactPaginate
                            previousLabel={"Previous"}
                            nextLabel={"Next"}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={pageCount}
                            onPageChange={handlePageClick}
                            containerClassName={"pagination mb-5"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"} />
                        </div>
                    </div>
                </div>
            </div>

            {/* ====================================== */}
                            {/* Modal */}
            {/* ====================================== */}
            
            <Modal onHide={handleClose} className='modal fade' size="lg" show={lgshow}>
                {/* <Modal.Header closeButton >
                <Modal.Title className='h5'>{modalTitle}</Modal.Title>
                </Modal.Header> */}
                <div className='modal-header pb-0 border-0 justify-content-end'>
                    <div className='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal' onClick={handleClose}>
                    <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
                    </div>
                </div>
                <Modal.Body data-backdrop='static' className='modal-body scroll-y mx-5 mx-xl-18 pt-0 pb-15' >
                    <div className='text-center mb-13'>
                        <h1 className='mb-3'>{modalTitle}</h1>
                    </div>

                    <Form onSubmit={handleBlogForm}>
                        
                        <Form.Group className='mt-3' controlId="BlogTitle">
                            <Form.Label>Blog Title <span className='text-danger'>*</span></Form.Label>
                            <Form.Control className='form-control-sm' type="text" placeholder="Enter blog title" value={blogTitle} onChange={(e)=> setBlogTitle(e.target.value)} required disabled={viewMode}/>
                            
                        </Form.Group>
                        <Form.Group className='mt-3' controlId="MetaTitle">
                            <Form.Label>Meta Title <span className='text-danger'>*</span></Form.Label>
                            <Form.Control className='form-control-sm' type="text" placeholder="Enter meta title" value={blogMetaTitle} onChange={(e)=> setBlogMetaTitle(e.target.value)} required disabled={viewMode}/>
                            
                        </Form.Group>
                        <Form.Group className='mt-3' controlId="MetaKeywords">
                            <Form.Label>Meta Keywords <span className='text-danger'>*</span></Form.Label>
                            <Form.Control className='form-control-sm' type="text" placeholder="Enter meta keywords" value={blogMetaKeywords} onChange={(e)=> setBlogMetaKeywords(e.target.value)} required disabled={viewMode}/>
                        </Form.Group>
                        <Form.Group className='mt-3' controlId="MetaDescription">
                            <Form.Label>Meta Description <span className='text-danger'>*</span></Form.Label>
                            <Form.Control className='form-control-sm' type="text" placeholder="Enter meta description" value={blogMetaDescription} onChange={(e)=> setBlogMetaDescription(e.target.value)} required disabled={viewMode}/>
                        </Form.Group>
                        <Form.Group className='mt-3' controlId="formBasicStatus">
                            <Form.Label>Status</Form.Label>
                            <Form.Select aria-label="Default select example" className='form-select-sm' value={blogStatus} onChange={(e)=> setBlogStatus(e.target.value)} disabled={viewMode}>
                                <option value='1'>Active</option>
                                <option value='0'>Inactive</option>
                            </Form.Select>
                        </Form.Group>
                         <Form.Group controlId="formBasicPhoto" className='mt-5 mb-2'>
                                <Form.Label>Thumbnail <span className='text-danger'>*</span></Form.Label>
                                <Form.Text className="text-muted">
                                    {fileSizeErrorThumbnail && <div className='text-danger'>(File size must be less than 300kb)</div>}
                                    {fileFormatErrorThumbnail && <div className='text-danger'>(File must be jpg / png / svg)</div>}
                                </Form.Text>
                                {viewMode === true ? '' :
                                    <Form.Control className='form-control-sm' type="file" placeholder="Enter Category Name" onChange={handleThumbnail} />
                                }
                            </Form.Group>
                            {
                                isEditThumbnail?(
                                    <img src={thumbnail_selected} alt="" width="100px" height="100px" className='mb-3' />
                                ):(
                                    ''
                                )
                            } 
                        <Form.Group className='mt-5 mb-2'>
                            <Form.Label>Short Description</Form.Label>
                            <textarea className='form-control' rows="3" placeholder="Enter short description" value={blogDescription} onChange={(e)=> setBlogDescription(e.target.value)} disabled={viewMode}></textarea>
                        </Form.Group>
                        <Form.Group className='mt-3' controlId="BlogContent">
                            <Form.Label>Blog Content <span className='text-danger'>*</span></Form.Label>
                            <div >
                            <ReactQuill style={{height:"200px"}} theme="snow" value={quillValue} onChange={setQuillValue} modules={modules} disabled={viewMode}/>
                            </div>
                        </Form.Group>
                    </Form>

                </Modal.Body>
                    {/* modal footer */}
                    {viewMode ? '': (
                        <div className='modal-footer d-flex justify-content-center pt-4'>
                            <button type='button' className='btn btn-sm btn-flex btn-light btn-active-light-primary me-2' onClick={handleClose}>
                                Close
                            </button>
                            <button type='button' className='btn btn-sm btn-flex btn-primary' id="btn-submit2" onClick={handleBlogForm}>
                                {modalTitle}
                            </button>
                        </div>
                    )}
            </Modal>
        </>
    )
}

export default Blogs
